import React from 'react'
import { Tooltip } from 'react-tooltip'

// Tranlations
import t from '../../../translations'

const Burger = (props) => {

    return <>
    <Tooltip id='toggle-language' className='tooltip'></Tooltip>
    <div
        style={{ display: 'inline'}}
        data-tooltip-id='toggle-language'
        data-tooltip-content={props.burgerModalOpen ? t[props.lang]['Close Menu'] : t[props.lang]['Open Menu']}
        data-tooltip-place='left'
        >
        <box-icon
            type='regular'
            name='menu'
            color='white'
            onClick={props.handleBurger}
        />
    </div>
    </>
}

export default Burger